/**
* TimelineCollapseToggle Component
*
* Controls the collapsing of all crops currently expanded.
*/

import React from 'react'
import { VerticalAlignCenter } from '@mui/icons-material'
import { TpToggleButton } from '~/components/tp-toggle-button'
import { useTimelineContextDispatch, setExpandedIds } from '../../context/timeline-context'
import { useTimelineStaticContext } from '../../context/timeline-static-context'
import { Stack, useMediaQuery, useTheme } from '@mui/material'
import { TpControlTooltip } from '../../../../../components/tp-control-tooltip'
import { CONTROLS_BREAKPOINT } from './timeline-controls-constants'
import { useEditCropContext } from '~/crop/edit-crop/edit-crop-context'

export const TimelineCollapseToggle = () => {
  const theme = useTheme()
  const isExpanded = useMediaQuery(theme.breakpoints.up(CONTROLS_BREAKPOINT))
  const { expandedIds } = useTimelineStaticContext()
  const dispatch = useTimelineContextDispatch()
  const hasExpandedCrops = expandedIds && expandedIds.length > 0

  const handleCollapseAll = () => {
    dispatch(setExpandedIds({ expandedIds: [] }))
  }

  if (isExpanded) {
    return (
      <TimelineCollapseToggleContent
        {...{ hasExpandedCrops, handleCollapseAll }}
        sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
      />
    )
  }

  return (
    <TimelineCollapseToggleContent {...{ hasExpandedCrops, handleCollapseAll }} />
  )
}

const TimelineCollapseToggleContent = ({ hasExpandedCrops, handleCollapseAll, ...rest }) => {
  const editCtx = useEditCropContext()
  const isEditing = editCtx?.editingCropId !== null
  const disabled = isEditing || !hasExpandedCrops

  return (
    <TpToggleButton disabled={disabled} onClick={handleCollapseAll} {...rest}>
      <TpControlTooltip title="Collapse" offsetBottom={-8}>
        <Stack>
          <VerticalAlignCenter sx={{ fontSize: 20 }} />
        </Stack>
      </TpControlTooltip>
    </TpToggleButton>
  )
}
